export const ACTIVE_DUPLICATE_STATUSES = ['pending', 'running'];

export function isActiveDuplicateJob(job) {
    return job && ACTIVE_DUPLICATE_STATUSES.includes(job.status);
}

export function buildDuplicatePlaceholder(job) {
    const source = job.sourceProjectSnapshot || {};
    return {
        id: `duplicate-job-${job.jobId}`,
        duplicateJobId: job.jobId,
        isDuplicatePlaceholder: true,
        project_name: job.projectName,
        project_type: source.project_type || '--',
        company_name: source.company_name || '--',
        investor_name: source.investor_name || '--',
        status: source.status,
        project_deadline: source.project_deadline,
        lead_consultant: source.lead_consultant,
        archive: false,
        soft_delete: false,
        duplicated: true,
        projectprogress: {
            last_updated: null,
            task_summary: { total: 0 },
            key_task: '',
            key_task_info: {},
        },
        vdr: {
            documents_count: 0,
            vdr_admin: source.vdr_admin,
        },
        project_admins: source.project_admins || [],
        team_members: source.team_members || [],
    };
}

export function snapshotSourceProject(sourceProject) {
    if (!sourceProject) return {};
    return {
        project_type: sourceProject.project_type,
        company_name: sourceProject.company_name,
        investor_name: sourceProject.investor_name,
        status: sourceProject.status,
        project_deadline: sourceProject.project_deadline,
        lead_consultant: sourceProject.lead_consultant,
        vdr_admin: sourceProject.vdr?.vdr_admin,
        project_admins: sourceProject.project_admins,
        team_members: sourceProject.team_members,
    };
}
